import { AxiosError } from "axios";
import { ApiAuthorized } from "../../../api/api";
import { GeneralInterface } from "../../../interfaces/general.interface";
import {
  GridProductData,
  GridProductResultInterface,
} from "../interfaces/product-result.interface";
import { GridProductSingleResultInterface } from "../interfaces/product-single-result.interface";

export interface GetAllGridProductParam {
  page?: number;
  limit?: number;
  search?: string;
  "filter.brand.id"?: string;
}

export const GetAllGridProduct = async (
  params: GetAllGridProductParam
): Promise<GridProductResultInterface> => {
  try {
    let response = await ApiAuthorized.get("/grid-products", {
      params: params,
    });
    return response.data;
  } catch (e) {
    let a = e as AxiosError;
    let response: GridProductResultInterface = a.response?.data;
    return response;
  }
};

export const ShowGridProduct = async (
  productId: string
): Promise<GridProductSingleResultInterface> => {
  try {
    let response = await ApiAuthorized.get("/grid-products/" + productId);
    return response.data as GridProductSingleResultInterface;
  } catch (e) {
    let a = e as AxiosError;
    let response: GridProductSingleResultInterface = a.response?.data;
    return response;
  }
};

export const SubmitGridProduct = async (
  form: GridProductData
): Promise<GridProductSingleResultInterface> => {
  try {
    let response = await ApiAuthorized.post("/grid-products", form);
    return response.data as GridProductSingleResultInterface;
  } catch (e) {
    let a = e as AxiosError;
    let response: GridProductSingleResultInterface = a.response?.data;
    return response;
  }
};

export const UpdateGridProduct = async (
  id: string,
  form: GridProductData
): Promise<GridProductSingleResultInterface> => {
  try {
    let response = await ApiAuthorized.patch("/grid-products/" + id, form);
    return response.data as GridProductSingleResultInterface;
  } catch (e) {
    let a = e as AxiosError;
    let response: GridProductSingleResultInterface = a.response?.data;
    return response;
  }
};

export const DeleteGridProduct = async (
  id: string
): Promise<GeneralInterface> => {
  try {
    let response = await ApiAuthorized.delete("/grid-products/" + id);
    return response.data as GeneralInterface;
  } catch (e) {
    let a = e as AxiosError;
    let response: GeneralInterface = a.response?.data;
    return response;
  }
};
